module.exports = __webpack_public_path__ + "img/ic_chengjidan_16.06a91eb0.svg";